import { render, staticRenderFns } from "./FormBuilderV3.vue?vue&type=template&id=3521efb0&scoped=true"
import script from "./FormBuilderV3.vue?vue&type=script&lang=js"
export * from "./FormBuilderV3.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderV3.vue?vue&type=style&index=0&id=3521efb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521efb0",
  null
  
)

export default component.exports